import React from 'react';
import useMyAppStore from '../../../stores/myAppStore';

const TestMyAppStore = () => {
  const { 
    products, 
    addProduct, 
    setProducts,
    isLoading,
    error 
  } = useMyAppStore();

  const handleAddProduct = () => {
    const newProduct = {
      id: Date.now(),
      name: `Produit ${products.length + 1}`,
      price: Math.random() * 100
    };
    addProduct(newProduct);
  };

  const handleClearProducts = () => {
    setProducts([]);
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Test Store MyApp</h2>
      
      <div className="space-y-4">
        <div className="flex gap-2">
          <button 
            onClick={handleAddProduct}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Ajouter un produit
          </button>
          <button 
            onClick={handleClearProducts}
            className="bg-red-500 text-white px-4 py-2 rounded"
          >
            Effacer les produits
          </button>
        </div>

        {isLoading && <p>Chargement...</p>}
        {error && <p className="text-red-500">{error}</p>}

        <div className="mt-4">
          <h3 className="font-bold mb-2">Liste des produits :</h3>
          <ul className="space-y-2">
            {products.map(product => (
              <li key={product.id} className="p-2 bg-gray-100 rounded">
                {product.name} - {product.price.toFixed(2)}€
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TestMyAppStore; 